<template>
    <div @click="clickHandler">
        <slot>
            <button class="button-third-party btn btn-block" :data-tpa-type="tpaType">
                <div class="icon-wrapper">
                    <svgIcon icon-holder-class="icon-third-party" icon-id="icon-ext-x" />
                </div>
                <span class="social-text">Continue with X</span>
            </button>
        </slot>
    </div>
</template>

<script>
import queryString from 'query-string';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'ButtonTwitter',
    components: {
        svgIcon,
    },
    props: {
        tpaType: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        oauthState: {
            type: Object,
            default: null,
        },
    },
    computed: {
        isApplication() {
            return this.$store.state.isApplication;
        },
        baseCallbackUri() {
            return `${location.origin}/account/login/callback/twitter`;
        },
    },
    methods: {
        clickHandler() {
            if (this.disabled) return;

            this.$emit('click', 'Twitter');

            const params = new URLSearchParams(),
                clientCode = this.$uuid.v4(),
                return_url = this.$route.query.return_url,
                state = {
                    ...(this.oauthState || {}),
                    ...(return_url ? { return_url } : {}),
                    ...(this.isApplication ? { clientCode } : {}),
                    ...(this.$route.query.unified ? { unified: 'unified' } : {}),
                };

            if (Object.keys(state).length > 0) {
                params.set('twitter_state', queryString.stringify(state));
            }
            const string_params = params.toString(),
                redirect_uri = `${this.baseCallbackUri}${string_params ? `?${string_params}` : ''}`;

            this.$accountAPI
                .get('/no-auth/login/twitter/authorize-uri', { params: { redirect_uri } })
                .then(({ authorizeUri }) => {
                    if (!authorizeUri) return;
                    if (this.isApplication) {
                        this.$router.push({
                            name: 'login-tpa-callback-app',
                            params: { clientCode, socialProvider: 'Twitter', url: authorizeUri },
                        });
                    } else {
                        window.location = authorizeUri;
                    }
                });
        },
    },
};
</script>

<style lang="less" scoped>
button {
    background-color: #1da1f2;
    &:hover {
        background-color: #63bcf2;
    }
    &:focus {
        background-color: #008de3;
    }
}

.button-third-party {
    margin: 0 0 10px;
    padding: 14px 0px;
    position: relative;
    .icon-wrapper {
        display: inline-flex;
        padding-right: 14px;
        vertical-align: middle;
        margin-top: -2px;
        .icon-third-party {
            width: 22px;
            height: 22px;
        }
    }
    .social-text {
        vertical-align: middle;
        color: #ffffff;
        font-size: 15px;
    }
}
</style>
